<div class="empty-placeholder" [ngStyle]="{ 'width.px': width }">
	<div class="robot-placeholder m-b-sm">
		<span [class]="placeholderClass">
			<img
				[src]="placeholderPath"
				[style]="placeholderStyles"
				alt="empty placeholder illustration"
			/>
		</span>
	</div>
	<h3 [class]="titleClass">{{ title | translate }}</h3>
	@if (description) {
		<p [ngClass]="descriptionClass" [innerHTML]="description | translate">
			{{ description | translate }}
		</p>
	}
	@if (list) {
		<ul>
			@for (item of list; track item) {
				<li>{{ item }}</li>
			}
		</ul>
	}
	@if (label) {
		<span class="label">{{ label }}</span>
	}
	<div [matTooltip]="tooltipText" class="actions">
		@if (link) {
			<a [routerLink]="link" class="link-button">{{ linkText }}</a>
		}
		@if (link && buttonText) {
			<span>or</span>
		}
		@if (buttonText) {
			<div
				[matTooltip]="disableButton ? disabledButtonTooltipText : ''"
				matTooltipPosition="below"
			>
				<button
					mat-flat-button
					class="empty-placeholder-action-btn au-disable-focused-overlay"
					(click)="callToAction()"
					[disabled]="disableButton"
				>
					@if (iconName) {
						<mat-icon [svgIcon]="iconName">{{ iconName }}</mat-icon>
					}
					<span>{{ buttonText | translate }}</span>
				</button>
			</div>
		}
	</div>
</div>
